import React, { useEffect } from 'react'
import { openNotificationWithIcon } from '../../../../utils/notification.helper'
import { useSelector } from 'react-redux'
import { Alert, Button, Flex, Form, Input, Select } from 'antd'
import { useUpdateOrganizationLmsConfigMutation, useFetchLmsConfigQuery } from '../../../../store/apis/lms.api'
import { useForm, useWatch } from 'antd/es/form/Form'
import userSelectors from '../../../../store/selectors/user.selectors'
import { useFetchOrganizationsQuery } from '../../../../store/apis/organization.api'
import { useAutoFocusFirstInput } from '../../../../../hooks/useAutoFocusFirstInput'

const CreateOrganizationLmsConfigForm = () => {
    const user = useSelector(state => state.auth.user)
    const [updateOrganizationLmsConfig, updateOrganizationLmsConfigResult] = useUpdateOrganizationLmsConfigMutation()
    const { data: organizations } = useFetchOrganizationsQuery()
    const [form] = useForm()
    useAutoFocusFirstInput()
    const isAdmin = useSelector(userSelectors.isAdmin)

    const organizationId = useWatch('organizationId', form) ?? user.organization_id

    const { data: lmsConfig } = useFetchLmsConfigQuery({ organizationId: !isAdmin ? undefined : organizationId })

    useEffect(() => {
        form.setFieldsValue(lmsConfig)
    }, [lmsConfig])

    const organizationOptions = organizations?.map(organization => ({
        value: organization.id,
        label: organization.name,
    }))

    const onSubmit = async values => {
        const response = await updateOrganizationLmsConfig({
            organizationId: !isAdmin ? undefined : organizationId,
            lmsUrl: values.lmsUrl,
            token: values.token,
        })

        if ('data' in response) {
            openNotificationWithIcon('success', 'Saved successfully')
        }
    }

    return (
        <Form
            name='create-organization-lms-config-form'
            onFinish={onSubmit}
            layout='vertical'
            requiredMark={false}
            validateTrigger={['onBlur', 'onSubmit']}
            form={form}
            defaultValue={{
                organizationId: user.organization_id,
            }}
        >
            {isAdmin && (
                <Form.Item
                    label='Organization'
                    name='organizationId'
                    rules={[{ required: true, message: 'Please, select organization to configure LMS for' }]}
                >
                    <Select
                        placeholder='Please, select organization to configure LMS for'
                        notFoundContent='There are no organizations'
                        loading={!organizations}
                        options={organizationOptions}
                        showSearch
                        popupMatchSelectWidth={false}
                        getPopupContainer={triggerNode => triggerNode.parentNode}
                        optionFilterProp='label'
                    />
                </Form.Item>
            )}
            <Form.Item
                label='LMS URL'
                name='lmsUrl'
                rules={[
                    { required: true, message: 'Please, input LMS URL' },
                    { type: 'url', message: 'Please, input valid URL' },
                ]}
            >
                <Input />
            </Form.Item>
            <Form.Item label='Token' name='token' rules={[{ required: true, message: 'Please, input token' }]}>
                <Input type='password' />
            </Form.Item>
            {updateOrganizationLmsConfigResult?.isError && (
                <Alert message={updateOrganizationLmsConfigResult?.error} type='error' showIcon />
            )}
            <Flex justify='end' gap={8}>
                <Form.Item className='mb-0'>
                    <Button type='primary' htmlType='submit' loading={updateOrganizationLmsConfigResult?.isLoading}>
                        Save
                    </Button>
                </Form.Item>
            </Flex>
        </Form>
    )
}

export default CreateOrganizationLmsConfigForm
